export const SET_STEPS = 'SET_STEPS'
export const CLEAR_STEPS = 'CLEAR_STEPS'
export const SET_JOYRIDE_OBJECT = 'SET_JOYRIDE_OBJECT'
